module.exports = __webpack_public_path__ + "static/media/box_02_page01.365ed0ac.png";